/**
 * 客户信息
 */
import React from 'react';
import { Row, Col, Icon, Tooltip, DatePicker, Button, Input } from 'antd';
import PageLayout from '../../ui/PageLayout';
//客户信息
import BillInfoDetail from './BillInfoDetail';
import http from '../../../axios/http';
import { global_data } from '../../ui/auth'

class ClientInfoIndex extends React.Component {

    columns = [{
        title: '客户名称',
        dataIndex: 'clientName',
        width: '15%',
    }, {
        title: '合同编号',
        dataIndex: 'contractCode',
        width: '15%',
    }, {
        title: '铺位号',
        dataIndex: 'berths',
        width: '10%',
    }, {
        title: '合约成交金额',
        dataIndex: 'totalAmount',
        width: '10%'
    }, {
        title: '押金金额',
        dataIndex: 'leaseDepositFee',
        width: '10%'
    }, {
        title: '起租时间',
        dataIndex: 'rentStartDate',
        width: '15%'
    }, {
        title: '退租时间',
        dataIndex: 'rentEndDate',
        width: '15%'
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record.id)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        detailData:{},
        loadData: '',
        queryData: {},
        detailVisible: false,
    };


    hiddenDetailModal = () => {
        this.setState({ detailVisible: false });
    }

    detail = (info, e) => {
        http.get({
            url: '/market/bill/query/' + info,
            success: (res) => {
                this.setState({ detailData: res, detailVisible: true });
            }
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        this.setState({ loadingVisible: true });
        http.download({
            url: '/market/bill/download/billInfo',
            data: queryData,
            fileName: "账单信息.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="客户名"
                                    onSearch={this.inputSearch}
                                    style={{ width: 250, marginRight: '10px' }}
                                    enterButton
                                />
                                <DatePicker.RangePicker
                                    defaultValue={[null, null]}
                                    allowClear={false}
                                    onChange={this.rangePickerChange} />
                            </Col>
                            <Col span={4}>
                            {global_data.authCode.includes("MARKET_BILL_EXPORT")?
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>:""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/market/bill/query/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <BillInfoDetail
                    successCallback={this.reloadDataFunc}
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenDetailModal.bind(this)}
                    detailData={this.state.detailData}
                    codeList={this.state.codeList}
                />
            </div>
        )
    }
}

export default ClientInfoIndex;